<template>
  <div>

      <vue-element-loading :active="appLoading" :is-full-screen="true" />
      <b-row class="py-3">
        <b-col>
          <span style="font-size: 18px"> <b> USER LOCATIONS</b></span>
        </b-col>
      </b-row>
      <div id="mapnew"></div>

  </div>
</template>

<script>
// import func from '../../../vue-temp/vue-editor-bridge';
var marker
export default {
  data () {
    return {
      userData: [],
      appLoading: false,
    }
  },
  mounted () {
    this.map1()
  },

  methods: {
    map1 () {
      this.appLoading = true
      axios({
        method: 'POST',
        url: '/user/list',
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.userData = response.data.data
            this.appLoading = false

            var mapCanvas = document.getElementById('mapnew')

            var mapOptions = {
              center: new google.maps.LatLng(20.38, 80.12),
              zoom: 5,
              mapTypeId: google.maps.MapTypeId.TERRAIN,
            }
            var vm = this

            vm.map = new google.maps.Map(mapCanvas, mapOptions)

            // var data = {};
            //  var icon = {
            //        url:this.imageURL+"/redMarker.png", // url
            //       scaledSize: new google.maps.Size(20, 32), // scaled size
            //       origin: new google.maps.Point(0, 0), // origin
            //       anchor: new google.maps.Point(0, 0), // anchor
            //     };

            for (var i = 0; i < this.userData.length; i++) {
              var lat = this.userData[i].location[1]
              var lon = this.userData[i].location[0]
              var latlngset = new google.maps.LatLng(lat, lon)

              marker = new google.maps.Marker({
                map: vm.map,
                position: latlngset,
                //    icon:icon,
              })
              var content =
               '<span>User ID: <span style="color:red">' +
                this.userData[i].userID +
                '</span></span>' +
                '<p>Name: <span style="color:red">' +
                this.userData[i].fullName +
                '</span></p>' +
                this.userData[i].email +
                '<p>' +
                this.userData[i].phone +
                '</p>' +
                '<a href="/userview/' +
                this.userData[i]._id +
                '"><button class="btn btn-success" >View Details</button></a>'

              var infowindow = new google.maps.InfoWindow()
              google.maps.event.addListener(
                marker,
                'click',
                (function (marker, content, infowindow) {
                  return function () {
                    infowindow.setContent(content)
                    infowindow.open(vm.map, marker)
                  }
                })(marker, content, infowindow)
              )
            }
            this.appLoading = false
          } else if (response.data.status === false) {
            this.appLoading = false
          }
        })
        .catch((e) => {
          this.appLoading = false
          // this.errors.push(e);
          this.msg = 'failed'
        })
    },
  },
}
</script>
<style scoped>
#mapnew {
  height: 600px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>
